export default __webpack_public_path__ + "static/nodeOperator-ae5ae769564b7a14987ba694442a937a.png";